// extracted by mini-css-extract-plugin
module.exports = {"day":"styles_day__KyDgY","sec":"styles_sec__Bpqd0","title":"styles_title__gbftm"};